import React from 'react'

import FormManager from "../../common/form-manager"
import FieldsFactory1 from "../../../fields/fields-factory"

type Props = {
    className?      : string

    form            : FormManager
    name            : string

    customFieldId   : ID
    params          : any
}

export default class CustomFieldFormElement extends React.Component<Props> {

    constructor(props: Props) {
        super(props)

        props.form.registerFormComponent(props.name,this)
    }

    onChange = (newValue: any) => {
        this.props.form.onFormComponentValueChange(this.props.name,newValue)
    }

    render() {
        const customFieldValue = this.props.form.getValue(this.props.name)

        const classes = Classes("custom-field-form-element form-type", this.props.className)

        const Field = FieldsFactory1.get(this.props.customFieldId)
        const RenderComponent = Field.EditComponent

        return (
            <RenderComponent
                mode        = "edit"
                className   = {classes}
                vaue        = {customFieldValue}
                canEdit     = {true}
                onChange    = {this.onChange} />
        )
    }
}
